import { render } from "./BePartnerRehabilitation.vue?vue&type=template&id=68d8793e&scoped=true"
import script from "./BePartnerRehabilitation.vue?vue&type=script&lang=js"
export * from "./BePartnerRehabilitation.vue?vue&type=script&lang=js"

import "./BePartnerRehabilitation.vue?vue&type=style&index=0&id=68d8793e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68d8793e"]])

export default __exports__